/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJobFamily } from '../models/CompanyJobFamily';
import type { CreateCompanyJobFamilyRequest } from '../models/CreateCompanyJobFamilyRequest';
import type { UpdateCompanyJobFamilyRequest } from '../models/UpdateCompanyJobFamilyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyJobFamilyService {

    /**
     * Create company job family
     * @returns CompanyJobFamily Success
     * @throws ApiError
     */
    public static createCompanyJobFamily({
        requestBody,
    }: {
        requestBody: CreateCompanyJobFamilyRequest,
    }): CancelablePromise<CompanyJobFamily> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobFamily',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Delete company job families
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyJobFamilies({
        jobFamilyIds,
    }: {
        /**
         * Job Family Ids To Delete
         */
        jobFamilyIds?: Array<number>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/jobFamily',
            query: {
                'jobFamilyIds': jobFamilyIds,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Update company job family
     * @returns CompanyJobFamily Success
     * @throws ApiError
     */
    public static updateCompanyJobFamily({
        id,
        requestBody,
    }: {
        /**
         * Company job family id
         */
        id: number,
        requestBody: UpdateCompanyJobFamilyRequest,
    }): CancelablePromise<CompanyJobFamily> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/jobFamily/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete company job family
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyJobFamily({
        id,
    }: {
        /**
         * Company job family id
         */
        id: number,
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/jobFamily/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export company job families
     * @returns any Success
     * @throws ApiError
     */
    public static exportCompanyJobFamily(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobFamily/export',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}
